import { Account } from "@modules/users/types/account";
import { User } from "@modules/users/types/user";

export class GlobalState {

    // Public
    public accessToken?: string;
    public account?: Account;
    public users?: User[];
    public currentProject?: string;
  
    /**
     * Constructor
     */
  
    constructor(jsonObject: any = {}) {
      this.accessToken = jsonObject['accessToken'];
      this.account = jsonObject['account'];
      this.users = jsonObject['users'] || [];
      this.currentProject = jsonObject['currentProject'];
    }
  }
  